#import "../fragments/edition-engagement-stats-fragment.graphql"

query GetEditionEngagementStats($editionId: ID!) {
    edition(id: $editionId) {
        ...EditionEngagementStats
    }
}
